import { render, staticRenderFns } from "./DetailBanKuai.vue?vue&type=template&id=0e5b05b6"
import script from "./DetailBanKuai.vue?vue&type=script&lang=js"
export * from "./DetailBanKuai.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports